import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const BlogPostTopicIdes = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12728"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12728)">
          <rect
            x="-19"
            y="-3"
            width="154"
            height="115"
            rx="4.96774"
            fill="#FFCBCB"
          />
          <g clipPath="url(#clip0_1529_12728)">
            <path
              d="M61.0925 24.3892V26.9071C61.0925 28.2296 59.9796 28.7619 58.3103 28.7619C56.641 28.7619 55.5281 28.2296 55.5281 26.9071V24.3892"
              fill="#E3E3E3"
            />
            <path
              d="M61.0925 24.3892V26.9071C61.0925 28.2296 59.9796 28.7619 58.3103 28.7619C56.641 28.7619 55.5281 28.2296 55.5281 26.9071V24.3892"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M60.6288 24.5886C61.7396 24.1483 62.6897 23.3798 63.3525 22.3856C64.0153 21.3915 64.3592 20.2189 64.3385 19.0242C64.3099 17.4344 63.6656 15.9176 62.5413 14.7932C61.4169 13.6689 59.9002 13.0246 58.3103 12.996C56.7204 13.0244 55.2035 13.6686 54.0791 14.793C52.9547 15.9174 52.3105 17.4343 52.2822 19.0242C52.2612 20.2189 52.605 21.3916 53.2678 22.3859C53.9306 23.3801 54.8809 24.1485 55.9918 24.5886H60.6288Z"
              fill="#FFEF5E"
            />
            <path
              d="M58.3104 16.0027C59.6508 16.0272 60.9462 16.4901 61.9986 17.3204C63.051 18.1508 63.8025 19.303 64.1383 20.6008C64.2764 20.0868 64.3438 19.5564 64.3386 19.0242C64.31 17.4344 63.6657 15.9176 62.5414 14.7932C61.417 13.6689 59.9003 13.0246 58.3104 12.996C56.7205 13.0244 55.2036 13.6686 54.0792 14.793C52.9548 15.9174 52.3106 17.4343 52.2823 19.0242C52.277 19.5564 52.3444 20.0868 52.4826 20.6008C52.8183 19.303 53.5698 18.1508 54.6223 17.3204C55.6747 16.4901 56.9701 16.0272 58.3104 16.0027Z"
              fill="#FFF9BF"
            />
            <path
              d="M60.6288 24.5886C61.7396 24.1483 62.6897 23.3798 63.3525 22.3856C64.0153 21.3915 64.3592 20.2189 64.3385 19.0242C64.3099 17.4344 63.6656 15.9176 62.5413 14.7932C61.4169 13.6689 59.9002 13.0246 58.3103 12.996C56.7204 13.0244 55.2035 13.6686 54.0791 14.793C52.9547 15.9174 52.3105 17.4343 52.2822 19.0242C52.2612 20.2189 52.605 21.3916 53.2678 22.3859C53.9306 23.3801 54.8809 24.1485 55.9918 24.5886H60.6288Z"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M58.3103 28.7618V30.153"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M58.3104 24.3104V20.4153L56.4556 18.5605"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M55.5281 26.4434H61.0925"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M58.3103 8.82269V10.6775"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M48.1089 18.0967H50.2336"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M50.4275 11.1411L52.2823 12.9959"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.5119 18.0967H66.3872"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M66.1934 11.1411L64.3386 12.9959"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M58.3103 20.4153L60.1651 18.5605"
              stroke="#191919"
              strokeWidth="0.931452"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M50.82 41.1154H16V74.9113H50.82V41.1154Z"
            fill="white"
          />
          <path
            d="M50.7721 41.1633H16.0481V38.3149C16.0481 37.701 16.292 37.1122 16.7261 36.678C17.1603 36.2439 17.7491 36 18.363 36H48.4572C49.0712 36 49.66 36.2439 50.0941 36.678C50.5282 37.1122 50.7721 37.701 50.7721 38.3149V41.1633Z"
            fill="#E3E3E3"
          />
          <path
            d="M20.678 61.9975H46.1423"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.678 66.0942H46.1423"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.0481 41.1633H50.7721"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.2567 39.2271C21.1032 39.2271 20.956 39.1661 20.8475 39.0576C20.739 38.9491 20.678 38.8019 20.678 38.6484C20.678 38.4949 20.739 38.3477 20.8475 38.2391C20.956 38.1306 21.1032 38.0696 21.2567 38.0696"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M21.2566 39.2271C21.4101 39.2271 21.5573 39.1661 21.6658 39.0576C21.7744 38.9491 21.8353 38.8019 21.8353 38.6484C21.8353 38.4949 21.7744 38.3477 21.6658 38.2391C21.5573 38.1306 21.4101 38.0696 21.2566 38.0696"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M25.8866 39.2271C25.7331 39.2271 25.5859 39.1661 25.4774 39.0576C25.3688 38.9491 25.3079 38.8019 25.3079 38.6484C25.3079 38.4949 25.3688 38.3477 25.4774 38.2391C25.5859 38.1306 25.7331 38.0696 25.8866 38.0696"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M25.8865 39.2271C26.04 39.2271 26.1872 39.1661 26.2957 39.0576C26.4042 38.9491 26.4652 38.8019 26.4652 38.6484C26.4652 38.4949 26.4042 38.3477 26.2957 38.2391C26.1872 38.1306 26.04 38.0696 25.8865 38.0696"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M30.5165 39.2269C30.363 39.2269 30.2158 39.166 30.1073 39.0574C29.9987 38.9489 29.9377 38.8017 29.9377 38.6482C29.9377 38.4947 29.9987 38.3475 30.1073 38.239C30.2158 38.1304 30.363 38.0695 30.5165 38.0695"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M30.5166 39.2268C30.6701 39.2268 30.8173 39.1658 30.9258 39.0573C31.0344 38.9488 31.0953 38.8016 31.0953 38.6481C31.0953 38.4946 31.0344 38.3474 30.9258 38.2388C30.8173 38.1303 30.6701 38.0693 30.5166 38.0693"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M16 71.7482V38.3149C16 37.701 16.2439 37.1122 16.678 36.678C17.1122 36.2439 17.701 36 18.3149 36H48.4091C49.0231 36 49.6119 36.2439 50.046 36.678C50.4801 37.1122 50.724 37.701 50.724 38.3149V71.7482"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.2605 48.1104H22.1638C21.8568 48.1104 21.5624 48.2323 21.3454 48.4494C21.1283 48.6664 21.0063 48.9608 21.0063 49.2678V56.2126C21.0063 56.5196 21.1283 56.814 21.3454 57.0311C21.5624 57.2481 21.8568 57.3701 22.1638 57.3701H45.2605C45.5675 57.3701 45.8619 57.2481 46.0789 57.0311C46.296 56.814 46.4179 56.5196 46.4179 56.2126V49.2678C46.4179 48.9608 46.296 48.6664 46.0789 48.4494C45.8619 48.2323 45.5675 48.1104 45.2605 48.1104Z"
            fill="#66E1FF"
          />
          <path
            d="M46.08 48.446C45.9723 48.3386 45.8445 48.2535 45.7039 48.1955C45.5632 48.1375 45.4126 48.1078 45.2605 48.108H22.1638C21.8568 48.108 21.5624 48.23 21.3454 48.447C21.1283 48.6641 21.0063 48.9585 21.0063 49.2655V56.2103C21.0061 56.3624 21.0358 56.5131 21.0938 56.6537C21.1518 56.7943 21.2369 56.9221 21.3443 57.0298L46.08 48.446Z"
            fill="#C2F3FF"
          />
          <path
            d="M45.2124 48.11H22.1157C21.8087 48.11 21.5143 48.232 21.2973 48.4491C21.0802 48.6661 20.9583 48.9605 20.9583 49.2675V56.2123C20.9583 56.5193 21.0802 56.8137 21.2973 57.0308C21.5143 57.2478 21.8087 57.3698 22.1157 57.3698H45.2124C45.5194 57.3698 45.8138 57.2478 46.0308 57.0308C46.2479 56.8137 46.3698 56.5193 46.3698 56.2123V49.2675C46.3698 48.9605 46.2479 48.6661 46.0308 48.4491C45.8138 48.232 45.5194 48.11 45.2124 48.11Z"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.82 44.1154H66V77.9113H100.82V44.1154Z"
            fill="white"
          />
          <path
            d="M100.772 44.1633H66.0481V41.3149C66.0481 40.701 66.292 40.1122 66.7261 39.678C67.1603 39.2439 67.7491 39 68.363 39H98.4572C99.0712 39 99.66 39.2439 100.094 39.678C100.528 40.1122 100.772 40.701 100.772 41.3149V44.1633Z"
            fill="#E3E3E3"
          />
          <path
            d="M70.678 51.108H96.1423"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M70.678 55.2048H96.1423"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M66.0481 44.1633H100.772"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.2567 42.2271C71.1032 42.2271 70.956 42.1661 70.8475 42.0576C70.739 41.9491 70.678 41.8019 70.678 41.6484C70.678 41.4949 70.739 41.3477 70.8475 41.2391C70.956 41.1306 71.1032 41.0696 71.2567 41.0696"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M71.2566 42.2271C71.4101 42.2271 71.5573 42.1661 71.6658 42.0576C71.7744 41.9491 71.8353 41.8019 71.8353 41.6484C71.8353 41.4949 71.7744 41.3477 71.6658 41.2391C71.5573 41.1306 71.4101 41.0696 71.2566 41.0696"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M75.8866 42.2271C75.7331 42.2271 75.5859 42.1661 75.4774 42.0576C75.3688 41.9491 75.3079 41.8019 75.3079 41.6484C75.3079 41.4949 75.3688 41.3477 75.4774 41.2391C75.5859 41.1306 75.7331 41.0696 75.8866 41.0696"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M75.8865 42.2271C76.04 42.2271 76.1872 42.1661 76.2957 42.0576C76.4042 41.9491 76.4652 41.8019 76.4652 41.6484C76.4652 41.4949 76.4042 41.3477 76.2957 41.2391C76.1872 41.1306 76.04 41.0696 75.8865 41.0696"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M80.5165 42.2269C80.363 42.2269 80.2158 42.166 80.1073 42.0574C79.9987 41.9489 79.9377 41.8017 79.9377 41.6482C79.9377 41.4947 79.9987 41.3475 80.1073 41.239C80.2158 41.1304 80.363 41.0695 80.5165 41.0695"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M80.5166 42.2268C80.6701 42.2268 80.8173 42.1658 80.9258 42.0573C81.0344 41.9488 81.0953 41.8016 81.0953 41.6481C81.0953 41.4946 81.0344 41.3474 80.9258 41.2388C80.8173 41.1303 80.6701 41.0693 80.5166 41.0693"
            stroke="#191919"
            strokeWidth="1.10126"
          />
          <path
            d="M66 74.7482V41.3149C66 40.701 66.2439 40.1122 66.678 39.678C67.1122 39.2439 67.701 39 68.3149 39H98.4091C99.0231 39 99.6119 39.2439 100.046 39.678C100.48 40.1122 100.724 40.701 100.724 41.3149V74.7482"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M70.6299 62.3463H81.9708"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M70.6299 66.4428H81.9708"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.2605 59.6122H88.3157C88.0087 59.6122 87.7143 59.7341 87.4972 59.9512C87.2801 60.1683 87.1582 60.4627 87.1582 60.7697V67.7145C87.1582 68.0214 87.2801 68.3158 87.4972 68.5329C87.7143 68.75 88.0087 68.8719 88.3157 68.8719H95.2605C95.5675 68.8719 95.8619 68.75 96.0789 68.5329C96.296 68.3158 96.4179 68.0214 96.4179 67.7145V60.7697C96.4179 60.4627 96.296 60.1683 96.0789 59.9512C95.8619 59.7341 95.5675 59.6122 95.2605 59.6122Z"
            fill="#66E1FF"
          />
          <path
            d="M96.08 59.9478C95.9723 59.8404 95.8445 59.7553 95.7039 59.6973C95.5632 59.6393 95.4126 59.6096 95.2605 59.6099H88.3157C88.0087 59.6099 87.7143 59.7318 87.4972 59.9489C87.2802 60.1659 87.1582 60.4604 87.1582 60.7673V67.7121C87.1579 67.8642 87.1876 68.0149 87.2456 68.1555C87.3036 68.2961 87.3888 68.4239 87.4962 68.5316L96.08 59.9478Z"
            fill="#C2F3FF"
          />
          <path
            d="M95.2124 59.6119H88.2676C87.9606 59.6119 87.6662 59.7338 87.4491 59.9509C87.2321 60.168 87.1101 60.4624 87.1101 60.7693V67.7142C87.1101 68.0211 87.2321 68.3155 87.4491 68.5326C87.6662 68.7497 87.9606 68.8716 88.2676 68.8716H95.2124C95.5194 68.8716 95.8138 68.7497 96.0308 68.5326C96.2479 68.3155 96.3699 68.0211 96.3699 67.7142V60.7693C96.3699 60.4624 96.2479 60.168 96.0308 59.9509C95.8138 59.7338 95.5194 59.6119 95.2124 59.6119Z"
            stroke="#191919"
            strokeWidth="1.10126"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.6968 58.1017H36.5591V99.0001H78.6968V58.1017Z"
            fill="white"
          />
          <path
            d="M78.6387 58.1597H36.6172V54.7127C36.6172 53.9698 36.9123 53.2572 37.4377 52.7318C37.9631 52.2065 38.6756 51.9113 39.4186 51.9113H75.8373C76.5802 51.9113 77.2928 52.2065 77.8182 52.7318C78.3435 53.2572 78.6387 53.9698 78.6387 54.7127V58.1597Z"
            fill="#E3E3E3"
          />
          <path
            d="M42.1619 69.8753H55.8861"
            stroke="#191919"
            strokeWidth="1.3327"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.1619 74.8328H55.8861"
            stroke="#191919"
            strokeWidth="1.3327"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.2202 83.3723H73.036"
            stroke="#191919"
            strokeWidth="1.3327"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.2202 88.3301H73.036"
            stroke="#191919"
            strokeWidth="1.3327"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36.6172 58.1598H78.6387"
            stroke="#191919"
            strokeWidth="1.3327"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.9203 55.8165C42.7346 55.8165 42.5564 55.7428 42.4251 55.6114C42.2938 55.4801 42.22 55.3019 42.22 55.1162C42.22 54.9304 42.2938 54.7523 42.4251 54.621C42.5564 54.4896 42.7346 54.4158 42.9203 54.4158"
            stroke="#191919"
            strokeWidth="1.3327"
          />
          <path
            d="M42.9202 55.8165C43.1059 55.8165 43.2841 55.7428 43.4154 55.6114C43.5467 55.4801 43.6205 55.3019 43.6205 55.1162C43.6205 54.9304 43.5467 54.7523 43.4154 54.621C43.2841 54.4896 43.1059 54.4158 42.9202 54.4158"
            stroke="#191919"
            strokeWidth="1.3327"
          />
          <path
            d="M48.5231 55.8165C48.3374 55.8165 48.1592 55.7428 48.0279 55.6114C47.8965 55.4801 47.8228 55.3019 47.8228 55.1162C47.8228 54.9304 47.8965 54.7523 48.0279 54.621C48.1592 54.4896 48.3374 54.4158 48.5231 54.4158"
            stroke="#191919"
            strokeWidth="1.3327"
          />
          <path
            d="M48.5232 55.8165C48.7089 55.8165 48.8871 55.7428 49.0184 55.6114C49.1498 55.4801 49.2236 55.3019 49.2236 55.1162C49.2236 54.9304 49.1498 54.7523 49.0184 54.621C48.8871 54.4896 48.7089 54.4158 48.5232 54.4158"
            stroke="#191919"
            strokeWidth="1.3327"
          />
          <path
            d="M54.1259 55.8164C53.9401 55.8164 53.762 55.7426 53.6307 55.6112C53.4993 55.4799 53.4255 55.3018 53.4255 55.116C53.4255 54.9303 53.4993 54.7521 53.6307 54.6208C53.762 54.4894 53.9401 54.4156 54.1259 54.4156"
            stroke="#191919"
            strokeWidth="1.3327"
          />
          <path
            d="M54.126 55.8162C54.3117 55.8162 54.4899 55.7425 54.6212 55.6111C54.7525 55.4798 54.8263 55.3016 54.8263 55.1159C54.8263 54.9301 54.7525 54.752 54.6212 54.6207C54.4899 54.4893 54.3117 54.4155 54.126 54.4155"
            stroke="#191919"
            strokeWidth="1.3327"
          />
          <path
            d="M36.5591 95.1722V54.7128C36.5591 53.9698 36.8542 53.2573 37.3796 52.7319C37.905 52.2065 38.6175 51.9114 39.3605 51.9114H75.7792C76.5221 51.9114 77.2347 52.2065 77.7601 52.7319C78.2854 53.2573 78.5806 53.9698 78.5806 54.7128V95.1722"
            stroke="#191919"
            strokeWidth="1.3327"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.9686 66.5668H63.5643C63.1928 66.5668 62.8365 66.7143 62.5738 66.977C62.3111 67.2397 62.1636 67.596 62.1636 67.9675V76.3718C62.1636 76.7433 62.3111 77.0996 62.5738 77.3622C62.8365 77.6249 63.1928 77.7725 63.5643 77.7725H71.9686C72.3401 77.7725 72.6964 77.6249 72.959 77.3622C73.2217 77.0996 73.3693 76.7433 73.3693 76.3718V67.9675C73.3693 67.596 73.2217 67.2397 72.959 66.977C72.6964 66.7143 72.3401 66.5668 71.9686 66.5668Z"
            fill="#66E1FF"
          />
          <path
            d="M72.9603 66.973C72.83 66.843 72.6753 66.74 72.5052 66.6698C72.335 66.5996 72.1527 66.5636 71.9686 66.564H63.5643C63.1928 66.564 62.8365 66.7115 62.5738 66.9742C62.3112 67.2369 62.1636 67.5932 62.1636 67.9647V76.369C62.1632 76.5531 62.1992 76.7354 62.2694 76.9055C62.3396 77.0757 62.4426 77.2304 62.5726 77.3607L72.9603 66.973Z"
            fill="#C2F3FF"
          />
          <path
            d="M71.9105 66.5664H63.5062C63.1347 66.5664 62.7784 66.714 62.5157 66.9767C62.253 67.2394 62.1055 67.5956 62.1055 67.9671V76.3714C62.1055 76.7429 62.253 77.0992 62.5157 77.3619C62.7784 77.6246 63.1347 77.7721 63.5062 77.7721H71.9105C72.282 77.7721 72.6383 77.6246 72.9009 77.3619C73.1636 77.0992 73.3112 76.7429 73.3112 76.3714V67.9671C73.3112 67.5956 73.1636 67.2394 72.9009 66.9767C72.6383 66.714 72.282 66.5664 71.9105 66.5664Z"
            stroke="#191919"
            strokeWidth="1.3327"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1529_12728">
            <rect
              width="22.9758"
              height="22.9758"
              fill="white"
              transform="translate(46.8225 8)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
BlogPostTopicIdes.displayName = 'BlogPostTopicIdes';
